module.exports = __webpack_public_path__ + "static/img/logo.f3d1c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo.png
// module id = W1y7
// module chunks = 1